import { IFeatureProperties } from '../../../../../../common/types/map';
import { pluralize } from '../../../../../../common/utils/pluralize';

const OFFER_FORMS: [string, string, string] = ['объявление', 'объявления', 'объявлений'];

/**
 * Шапка шторки мультипина: «6 объявлений», без цены - как в приложениях (дизайн-ревью 2026-10-07).
 * Число полное (не «9+», как на пине).
 */
export function getMultipinSheetTitle({ offers }: IFeatureProperties): string {
  return `${offers.length} ${pluralize(offers.length, OFFER_FORMS)}`;
}
